import { type FC, useEffect, useState } from "react";
import { type ClientImage } from "@clientFrontend/features/publication/components/ClientImageLibraryModal/type";
import { useInView } from "react-intersection-observer";
import { Presentation } from "./Presentation";

type Props = {
  selectedImageIds: number[];
  clientImages: ClientImage[];
  handleClickClientImageCassette: (clientImage: ClientImage) => void;
};

export const ClientImageCassettes: FC<Props> = ({
  selectedImageIds,
  clientImages,
  handleClickClientImageCassette,
}) => {
  const [visibleClientImages, setVisibleClientImages] = useState<ClientImage[]>([]);
  // APIから取得したClientImageを、レイジーロードさせてs3への負荷などを下げる
  const { ref, inView } = useInView();

  // 初期表示として16個の画像を表示させる
  useEffect(() => {
    const initialDisplayImageCount = 16;
    setVisibleClientImages(clientImages.slice(0, initialDisplayImageCount));
  }, [clientImages]);

  // スクロールによってターゲット要素がビューポート内に入った場合、さらに8個の画像を追加で表示する
  useEffect(() => {
    if (inView) {
      const additionalDisplayImageCount = 8;
      setVisibleClientImages((prevImages) => [
        ...prevImages,
        ...clientImages.slice(prevImages.length, prevImages.length + additionalDisplayImageCount),
      ]);
    }
  }, [inView, clientImages]);

  return (
    <Presentation
      scrollTargetRef={ref}
      selectedImageIds={selectedImageIds}
      visibleClientImages={visibleClientImages}
      handleClickClientImageCassette={handleClickClientImageCassette}
    />
  );
};
